import 'url-search-params-polyfill';
/**
 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
 * @returns {object} Meta Object
 */
export const getPageMeta = () => {
	let data = {};
	let metaEl = document.querySelector('[fs-prop="analytics"]');
	if( ! metaEl ) return data;
	let atts = metaEl.attributes;
	for (let i=0,len=atts.length;i<len;i++) {
		if (atts[i].value) {
			let att = atts[i].name;
			let val = atts[i].value;

			att = (att.indexOf('-') >= 0) ? att.replace(/-/g, '_') : att;
			data[att] = val.trim();
		}
	}

	return data;
}

// query string helpers
export const setCampaignTraitsSession = () => {
	if (window.location.search.length == 0) return;

	const queryStr = window.location.search;
	const campaignTraits = {
		"org": "campaign_organization",
		"ag": "campaign_agency",
		"mc": "campaign_type",
		"src": "campaign_source",
		"cmp": "campaign_name",
		"add": "campaign_additional",
		"cmpid": "campaign_tracking_code"
	};	
	const query = new URLSearchParams(queryStr);
	const params = Object.keys(campaignTraits);
	let result;

	for (let key in query.keys()) {
		if (key in params) {
			if (!result) result = {};
			
			result[campaignTraits[key]] = query.get(key);
		}
	}

	if (result) {
		window.sessionStorage.setItem('sessionCampaignTraits', JSON.stringify(result));
	}

	return result;
};

export const getSessionCampaignTraits = () => {
	let result;

	try {
		result = JSON.parse(window.sessionStorage.getItem('sessionCampaignTraits'));
		if (!result) {
			result = setCampaignTraitsSession();
		}
	} catch (e) {
		return;
	}

	return result;
};


export const isObjectEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

/**
 * key for enntitlemtns
 */
const MVPD_KEY = "mvpd_entitlements";

/**
 * helper to get provider details
 */
export const providerUtils = {
	setEntitlementsList,
	getEntitlementsList,
	getMVPDId,
}

/**
* sets user entitlemetns and stores them in localstorage
* @param {Array} res - user entitlements response
*/
function setEntitlementsList(res) {
   const channels = res.channels.map(e => e.name);
   const ppvEvents = res.ppvEvents.map(e => e.uri);
   let entitlements = '';
   if(channels) {
	   entitlements = channels.toString();
   }
   if(ppvEvents && ppvEvents.length > 0) {
	   entitlements += `,${ppvEvents.toString()}`;
   }
   window.localStorage.setItem(MVPD_KEY, entitlements);
}

/**
 * @returns {string} returns entitlements list
 */
function getEntitlementsList() {
	const entitlements = window.localStorage.getItem(MVPD_KEY);
	if(entitlements) {
		return entitlements;
	}
	return '';
}

/**
 * returns mvpd id
 */
function getMVPDId() {
	const wisReg = window.wisRegistration;
	if (wisReg && typeof wisReg.getMVPDDetails === "function") {
		const details = wisReg.getMVPDDetails();
		if(details) {
			return details.providerId;
		}
		return '';
	}
}